import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fb0eb1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-card" }
const _hoisted_2 = { class: "card-wrapper" }
const _hoisted_3 = { class: "help-center" }
const _hoisted_4 = { class: "version" }
const _hoisted_5 = { class: "close-label" }
const _hoisted_6 = { class: "el-dropdown-link" }

import { useStore } from 'vuex';
	import { computed, reactive } from 'vue';
	import { useRouter, useRoute } from 'vue-router';
	import type { TabsPaneContext, TabPaneName } from 'element-plus';
	import { DArrowRight } from '@element-plus/icons-vue';
	import { getCurrentVersion } from '@/utils/localStorage';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'PageCard',
  setup(__props) {

	let router = useRouter();
	let route = reactive(useRoute());
	const store = useStore();
	let tabList = computed(() => store.state.menu.tabList);

	//点击标签
	const clickTab = (tab: TabsPaneContext, event: Event) => {
		router.push({
			name: tab.props.name,
		});
	};

	//移除标签
	const removeTab = (tabName: TabPaneName) => {
		//如果只剩下一个标签则不可以移除
		if (tabList.value.length <= 1) return;
		tabList.value.forEach((el: any, i: number) => {
			//确保移除的在tablist标签组里
			if (el.name == tabName) {
				if (route.meta.name == tabName) {
					//关闭当前标签
					store.commit('menu/deleteTabList', { start: i, end: 1 });
					if (i !== 0) {
						//当前标签不是第一个并切换到上一个标签
						router.push({
							name: tabList.value[i - 1].name,
						});
					} else {
						//当前标签是第一个
						router.push({
							name: tabList.value[i].name,
						});
					}
				} else {
					//关闭其他标签
					store.commit('menu/deleteTabList', { start: i, end: 1 });
				}
			}
		});
	};

	//右上角关闭
	const handleClickItem = (num: string) => {
		//0当前  1其他  2全部
		let item = {};
		tabList.value.forEach((el: any, i: number) => {
			if (el.name == route.meta.name) {
				item = el;
			}
		});
		switch (num) {
			case '0': //0关闭当前
				if (route.meta.name == 'Home') return;
				removeTab(item.name);
				break;
			case '1': //1关闭其他
				store.commit('menu/deleteAllTabList');
				store.commit('menu/addTabList', item);
				break;
			case '2': //关闭全部
				store.commit('menu/deleteAllTabList');
				router.push({
					name: tabList.value[0].name,
				});
				break;
		}
	};
	//版本号
	const currentVersion = getCurrentVersion();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        type: "border-card",
        "model-value": _unref(route).name,
        onTabRemove: removeTab,
        onTabClick: clickTab,
        closable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              label: item.title,
              name: item.name
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(currentVersion)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_dropdown, {
        trigger: "click",
        onCommand: handleClickItem
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "0" }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭当前页")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "1" }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭其他页")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "2" }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭全部页")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_el_icon, {
              class: "icon-gengduo",
              size: 25,
              color: "#d0d0d0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DArrowRight))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})